export const ENV = {
   PUBLIC_FF_URL: import.meta.env.VITE_APP_PUBLIC_FF_URL,
   STRIPE_ID: import.meta.env.VITE_APP_STRIPE_ID,
   CONFIGCAT_SDK_KEY: import.meta.env.VITE_APP_CONFIGCAT_SDK_KEY,
   NODE_ENV: import.meta.env.VITE_APP_NODE_ENV,
   MODE: import.meta.env.MODE,
   GOOGLE_MAPS_API_KEY: import.meta.env.VITE_APP_GOOGLE_MAPS_API_KEY,
   CAMPAIGN_WORKER_URL: import.meta.env.VITE_APP_CAMPAIGN_UI_WORKER_URL,
   CAMPAIGN_UI_WORKER_URL: import.meta.env.VITE_APP_CAMPAIGN_UI_WORKER_URL,
   TEXT_WORKER_API_URL: import.meta.env.VITE_APP_TEXT_WORKER_API_URL,
   PHONE_WORKER_API_URL: import.meta.env.VITE_APP_PHONE_WORKER_API_URL,
   CALL_WORKER_API_URL: import.meta.env.VITE_APP_CALL_WORKER_API_URL,
   LEAD_PROCESS_WORKER_URL: import.meta.env.VITE_APP_LEAD_PROCESS_WORKER_URL,
   FEATURE_DEMO_CONVERSATION: import.meta.env
      .VITE_APP_FEATURE_DEMO_CONVERSATION,
}
